import {Component, inject, OnInit} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {GridModel} from "src/app/shared/model/page-grid";
import {VendorStatementGridService} from "../../service/vendor-statement-grid.service";
import {DatePipe} from "@angular/common";
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {VendorBalanceModel} from "../../models/vendor-balances";

@Component({
    selector: 'app-vendor-statement',
    templateUrl: './vendor-statement.component.html',
    standalone: false
})
export class VendorStatementComponent implements OnInit {
    private dialogRef: MatDialogRef<VendorStatementComponent> | null = inject(MatDialogRef<VendorStatementComponent>, {optional: true});
    protected data = inject<VendorBalanceModel & {asOfDate: string}>(MAT_DIALOG_DATA, {optional: true});

    route = inject(ActivatedRoute);
    datePipe = inject(DatePipe);

    vendorId?:string;
    vendorName?: string;
    asOfDate?: string;

    gridName?: string;
    noData = false;

    protected readonly vendorStatementGrid: GridModel<any> = {
        gridDataTestId: 'vendor-statement-list',
        gridTitle: 'Vendor Statements',
        replayButton: false,
        pdfButton: true,
        singleColumnFilter: true,
        gridTitleFunction: (filter:any)=> `${this.vendorName} Vendor Statement As Of ${this.datePipe.transform(filter.asOfDate, 'dd MMMM yyyy')}`,
        defaultSort: { active: 'adxInvoiceIssueDate', direction: 'desc' },
        columns: [
          {
            columnProperty: 'adxInvoiceId',
            columnHeader: 'Fms Invoice Number',
            sort: true,
          },
          {
            columnProperty: 'adxBookingId',
            columnHeader: 'Fms Service Number',
            sort: true,
          },
          {
            columnProperty: 'adxInvoiceIssueDate',
            columnHeader: 'Invoice Issue Date',
            sort: true,
            processData: (statement)=> this.datePipe.transform(statement, 'M/dd/yyyy') || '',
          },
          {
            columnProperty: 'adxBookingStartDate',
            columnHeader: 'Service Start Date',
            sort: true,
            processData: (statement)=> this.datePipe.transform(statement, 'M/dd/yyyy') || '',
          },
          {
            columnProperty: 'vendorName',
            columnHeader: 'Main Client Name',
            sort: true,
            textLeft: true,
          },
          {
            columnProperty: 'adxBookingTotalFare',
            columnHeader: 'Total Fare',
            sort: true,
          },
          {
            columnProperty: 'adxBookingTotalTaxes',
            columnHeader: 'Total Taxes',
            sort: true,
          },
          {
            columnProperty: 'accountBalance',
            columnHeader: 'Account Balances',
            sort: true,
          },
        ],
        filters: [
          {
            filterProperty: 'asOfDate',
            filterDisplayName: 'As Of Date',
            filterType: 'DATE',
          }
        ],
        gridGetService: inject(VendorStatementGridService)
    };

    constructor() {
      if(this.data) {
        this.vendorId = `${this.data.id}`;
        this.vendorName = this.data.vendorName;
        this.asOfDate = this.data.asOfDate;
      } else {
        this.vendorId = this.route.snapshot.paramMap.get('vendorId') ?? '';
        this.vendorName = this.route.snapshot.queryParamMap.get('VendorName') ?? '';
        this.asOfDate = this.route.snapshot.queryParamMap.get('AsOfDate') ?? '';
      }

      if(this.vendorName && this.vendorId && this.asOfDate) {
          this.gridName = `${this.vendorName} Vendor Statement As Of ${this.datePipe.transform(this.asOfDate, 'dd MMMM yyyy')}`;
      } else {
        this.noData = true;
      }
    }

    ngOnInit(): void {
      if(this.gridName) {
        this.vendorStatementGrid.gridTitle = this.gridName;
        this.vendorStatementGrid.filtersInitial = {
            vendorId: this.vendorId ?? '',
            asOfDate: new Date(this.asOfDate!) ?? '',
        };
      }
    }

    closeModal(): void {
      if(this.dialogRef) {
        this.dialogRef.close();
      }
    }
}